(function ($) {
    var themeUrl = custom.theme_url;
    var $win = $(window);
    var $doc = $(document);
    var $body = $('body');
    /* ------------------------------ /
     * Font Loader setup.
     * ------------------------------ */
    WebFont.load({
        custom: {
            families: ['work_sans'],
            urls: [custom.theme_url + '/css/fonts.min.css']
        }
    });

    /* ------------------------------ /
     * Polyfill init.
     * ------------------------------ */
    objectFitImages();

    /* ------------------------------ /
     * Detect Mouse movement for accessibility
     * ------------------------------ */
    $doc.ready(function () {
        $body.keydown(function (e) {
            if (e.keyCode == '9') { // Tab key pressed
                addClickCatcher();
            }
        });
    });

    function addClickCatcher() {
        $body.removeClass('mouse-enabled');
        if (!$('.mouse-catcher').length) {
            $body.append('<div class="mouse-catcher"></div>');
            $('.mouse-catcher').on('click mousemove', function () {
                $body.addClass('mouse-enabled');
                $(this).remove();
            });
        }
    }

    /* ------------------------------ /
     * Main menu setup.
     * ------------------------------ */
    var menuBreakpoint = 992;

    $('.search-toggle').click(function () {
        var $this = $(this);
        $this.toggleClass('active');
        if ($this.hasClass('active')) {
            $this.next('form').find('input[type=text]').focus();
        }
    });

    $('.navbar.site-navigation .menu-item-has-children').append('<span class="dropdown-menu-toggle"></span>');
    $('.dropdown-menu-toggle').click(function () {
        $(this).parent().toggleClass('open');
    });

    $('.menu-button').click(function () {
        $(this).toggleClass('active');
    });

    $('.main-nav-menu .close').click(function () {
        $('.menu-button').removeClass('active');
    });

    $('.main-nav-menu .menu-item-has-children').each(function () {
        var $thisItem = $(this);
        var $thisLink = $thisItem.find('> a');
        var $thisSub = $thisItem.find('> .sub-menu');
        var $thisItemParent = $thisItem.parent();
        var $thisMenu = $thisItem.closest('.main-menu-wrapper');

        // Clone the link into the sub menu if it has a valid url
        if ($thisLink.attr('href') !== undefined && $thisLink.attr('href') !== '' && $thisLink.attr('href') !== '#') {
            var $linkClone = $thisLink.clone();
            var linkwrapper = '<li class="' + $thisItem.attr('class') + ' sub-menu-parent-link-duplicate"></li>';
            $linkClone.prependTo($thisSub);
            $linkClone.wrap(linkwrapper);
            $linkClone.parent().removeClass('menu-item-has-children');
        }

        // Append back button to sub menu
        $thisSub.prepend('<li class="sub-menu-back menu-item">Back</li>');

        // Click events to open and close the sub menu
        $thisLink.click(function (e) {
            if ($win.width() < menuBreakpoint) {
                e.preventDefault();
                $thisItemParent.find('> .active').removeClass('active');
                $thisItem.addClass('active');
                $thisMenu.addClass('sub-open');
            }
        });

        $thisSub.find('.sub-menu-back').click(function () {
            $thisMenu.removeClass('sub-open');
        });
    });

    $('.special .close').click(function () {
        var $special = $(this).closest('.special');
        $special.slideUp(function () {
            Cookies.set('hide_special', $special.data('specialid'));
            $(this).remove();
        });
    });

    /* ------------------------------ /
     * Particles setup.
     * ------------------------------ */
    if ($('#bubble-particles').length) {
        var particleOptions = {
            'particles': {
                'number': {
                    'value': 50,
                    'density': {
                        'enable': true,
                        'value_area': 800
                    }
                },
                'color': {
                    'value': '#fff'
                },
                'shape': {
                    'type': 'circle'
                },
                'size': {
                    'value': 30,
                    'random': true
                },
                'line_linked': {
                    'enable': false
                },
                'move': {
                    'enable': true,
                    'speed': 0.5,
                    'direction': 'top',
                    'random': false,
                    'straight': false,
                    'out_mode': 'out',
                    'bounce': false,
                    'attract': {
                        'enable': false,
                        'rotateX': 600,
                        'rotateY': 1200
                    }
                }
            },
            'interactivity': {
                'detect_on': 'canvas',
                'events': {
                    'onhover': {
                        'enable': true,
                        'mode': 'bubble'
                    },
                    'onclick': {
                        'enable': true,
                        'mode': 'repulse'
                    },
                    'resize': true
                },
                'modes': {
                    'bubble': {
                        'distance': 300,
                        'size': 20,
                        'duration': 4,
                        'opacity': 1,
                        'speed': 3
                    },
                    'repulse': {
                        'distance': 250,
                        'duration': 1.5
                    }
                }
            },
            'retina_detect': true
        };
        var baseColor = $('#bubble-particles').closest('section').css('backgroundColor');
        var particleColor = tinycolor(baseColor).spin(-3);
        if (particleColor.isDark()) {
            particleColor = tinycolor(particleColor).lighten(2).toHex();
            console.log('dark');
        }
        else {
            particleColor = tinycolor(particleColor).darken(2).toHex();
            console.log('light');
        }
        particleOptions.particles.color.value = particleColor.toString();

        particlesJS('bubble-particles', particleOptions);
    }

    /* ------------------------------ /
     * Form setup.
     * ------------------------------ */
    $('.gform_wrapper').each(function () {
        var $thisWrapper = $(this);
        var $thisBody = $thisWrapper.find('.gform_body');
        var $inputs = $thisBody.find('.gfield:not(".gform_validation_container")');

        if ($inputs.length < 2) {
            $thisWrapper.addClass('single-field');
        }
    });

    /* ------------------------------ /
     * Lightbox setup.
     * ------------------------------ */
    $('.lightbox .close').click(function () {
        $(this).closest('.lightbox-wrapper').fadeOut();
    });

    $('.lightbox-link').click(function (e) {
        $('.lightbox-wrapper').fadeIn();
        PDFObject.embed($(this).attr('href'), '#pdf-iframe');
    });

    /* ------------------------------ /
 * FAQ setup.
 * ------------------------------ */

    var reset;
    var faqTransitioning = false;
    $('.faq-item .label').click(function () {
        reset = setTimeout(function () {
            faqTransitioning = false;
        }, 100);
        if (!faqTransitioning) {
            clearTimeout(reset);
            faqTransitioning = true;
            var $this = $(this);
            var $item = $this.parent();
            var $group = $item.parent();
            if (!$item.hasClass('active')) {
                $group.find('.active .faq-content').slideUp(function () {
                    $(this).parent().removeClass('active');
                    $item.find('.faq-content').slideDown(function () {
                        $item.addClass('active');
                        faqTransitioning = false;
                        clearTimeout(reset);
                    });
                });
            }
        }
    });

    $('.faq-tabs .tab').click(function () {
        reset = setTimeout(function () {
            faqTransitioning = false;
        }, 100);
        if (!faqTransitioning) {
            clearTimeout(reset);
            faqTransitioning = true;
            var $this = $(this);
            var $section = $this.closest('.flip-columns');
            if (!$this.hasClass('active')) {
                var hash = $this.data('hash');
                var $activeCategory = $section.find('.faq-category.active');
                $section.find('.tab.active').removeClass('active');
                $this.addClass('active');
                $activeCategory.fadeOut(function () {
                    $activeCategory.removeClass('active');
                    $section.find('#' + hash).fadeIn(function () {
                        $(this).addClass('active');
                        faqTransitioning = false;
                        clearTimeout(reset);
                    });
                });
            }
        }
    });


    /* ------------------------------ /
     * Misc setup.
     * ------------------------------ */
    var $bannerCarousel = $('.home-banner-carousel');
    $bannerCarousel.on('changed.owl.carousel', function (event) {
        $(this).closest('section').addClass('loaded');
    });
    $bannerCarousel.owlCarousel({
        items: 1
        , touchDrag: false
        , mouseDrag: false
        , pullDrag: false
        , rewind: true
        , autoplay: true
        , nav: true
    });

    $('.quantity').each(function () {
        $(this).append('<div class="input_arrows"><div class="arrow up"></div><div class="arrow down"></div></div>');
        var $input = $(this).find('input');
        $(this).find('.arrow.down').click(function () {
            $input.val(function (i, oldval) {
                if (isNaN(oldval) || oldval === undefined || oldval === '') {
                    return 1;
                }
                return Math.max(1, parseInt(oldval, 10) - 1);
            });
            $input.change();
        });
        $(this).find('.arrow.up').click(function () {
            $input.val(function (i, oldval) {
                if (isNaN(oldval) || oldval === undefined || oldval === '') {
                    return 1;
                }
                else {
                    return Math.min(200, parseInt(oldval, 10) + 1);
                }
            });
            $input.change();
        });
    });
})(jQuery);
